<template>
  <div class="login-container">
    <!-- 移动端右上角标题 -->
    <div class="mobile-header" v-if="isMobile">
      <h1 class="mobile-brand-title">{{ loginType === 'hospital' ? '爱护无忧医院端管理系统' : '爱护无忧社区端管理系统' }}</h1>
      <p class="mobile-brand-slogan">AI引领康护 全程爱护无忧</p>
    </div>
    <div class="login-content">
      <div class="login-left">
        <div class="brand-info">
          <h1 class="brand-title">{{ loginType === 'hospital' ? '爱护无忧医院端管理系统' : '爱护无忧社区端管理系统' }}</h1>
          <p class="brand-slogan">AI引领康护 全程爱护无忧</p>
          <div class="brand-features">
            <!-- 医院端功能特色 -->
            <template v-if="loginType === 'hospital'">
              <div class="feature-item">
                <el-icon>
                  <Avatar />
                </el-icon>
                <span>一屏总览控制台</span>
              </div>
              <div class="feature-item">
                <el-icon>
                  <Document />
                </el-icon>
                <span>电子护工档案</span>
              </div>
              <div class="feature-item">
                <el-icon>
                  <ChatDotRound />
                </el-icon>
                <span>服务记录管理</span>
              </div>
              <div class="feature-item">
                <el-icon>
                  <SetUp />
                </el-icon>
                <span>智能排班专题</span>
              </div>
              <div class="feature-item">
                <el-icon>
                  <Reading />
                </el-icon>
                <span>在线培训考核</span>
              </div>
              <div class="feature-item">
                <el-icon>
                  <Microphone />
                </el-icon>
                <span>客户评价看板</span>
              </div>
              <div class="feature-item">
                <el-icon>
                  <Picture />
                </el-icon>
                <span>健康监测预警</span>
              </div>
              <div class="feature-item">
                <el-icon>
                  <Film />
                </el-icon>
                <span>移动护理指导</span>
              </div>
            </template>
            <!-- 社区端功能特色 -->
            <template v-else>
              <div class="feature-item">
                <el-icon>
                  <Avatar />
                </el-icon>
                <span>一屏总览控制台</span>
              </div>
              <div class="feature-item">
                <el-icon>
                  <Document />
                </el-icon>
                <span>社区服务AI助手</span>
              </div>
              <div class="feature-item">
                <el-icon>
                  <ChatDotRound />
                </el-icon>
                <span>居家自护评估</span>
              </div>
              <div class="feature-item">
                <el-icon>
                  <SetUp />
                </el-icon>
                <span>紧急救援响应</span>
              </div>
              <div class="feature-item">
                <el-icon>
                  <Reading />
                </el-icon>
                <span>智能设备共享</span>
              </div>
              <div class="feature-item">
                <el-icon>
                  <Microphone />
                </el-icon>
                <span>居民灵活就业</span>
              </div>
              <div class="feature-item">
                <el-icon>
                  <Picture />
                </el-icon>
                <span>养老政策答疑解读</span>
              </div>
              <div class="feature-item">
                <el-icon>
                  <Film />
                </el-icon>
                <span>护工档案护理报告管理</span>
              </div>
            </template>
          </div>
        </div>
        <!-- 添加数字人图片 -->
        <div class="digital-human-image"></div>
      </div>
      <div class="login-right">
        <div class="login-box">
          <h2 class="login-title">用户登录</h2>
          <!-- 登录类型切换 -->
          <div class="login-type-toggle">
            <button :class="['type-btn', { active: loginType === 'hospital' }]" @click="switchLoginType('hospital')">
              医院登录
            </button>
            <button :class="['type-btn', { active: loginType === 'community' }]" @click="switchLoginType('community')">
              社区登录
            </button>
          </div>
          <div class="input-group">
            <label for="username">用户名/简称</label>
            <div class="phone-input">
              <el-icon>
                <User />
              </el-icon>
              <input type="text" id="username" v-model="perUser.username" placeholder="请输入用户名/简称" />
            </div>
          </div>
          <div class="input-group">
            <label for="password">密码</label>
            <div class="code-input">
              <el-icon>
                <Lock />
              </el-icon>
              <input type="password" id="password" v-model="perUser.password" placeholder="请输入密码" />
            </div>
          </div>
          <button class="login-btn" @click="login_btn">
            <span>登 录</span>
            <div class="btn-effect"></div>
          </button>
          <div class="register-link">
            <p>还没有账号？<a @click="goToRegister">{{ loginType === 'hospital' ? '医院注册' : '社区注册' }}</a></p>
          </div>
          <div class="login-tips">
            <p>登录即表示您同意<a href="#">用户协议</a>和<a href="#">隐私政策</a></p>
          </div>
        </div>
      </div>
    </div>
    <!-- 移动端底部文本 -->
    <div class="mobile-footer" v-if="isMobile">
      <p>powered by 虚实科技</p>
    </div>
    <!-- PC端底部文本 -->
    <div class="pc-footer" v-if="!isMobile">
      <p>powered by 虚实科技</p>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, reactive, onMounted, onBeforeUnmount } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { ElNotification } from 'element-plus'
import { Phone, Lock, VideoPlay, Microphone, Document, Picture, Brush, Avatar, User, ChatDotRound, Film, SetUp, Reading } from '@element-plus/icons-vue'
// @ts-ignore: 自定义模块
import { getToken, setToken, removeToken, clearUserData } from '../common/auth'
// @ts-ignore: 自定义模块
import { hospitalLogin, loginnocode } from '../common/asi'

const router = useRouter()
const route = useRoute()

// 响应式状态
const courseId = ref('')
const toAIPainting = ref('')
const isMobile = ref(false) // 添加判断是否为移动设备的响应式变量
const loginType = ref('hospital') // 登录类型：'hospital' 或 'community'

// 用户信息
const perUser = reactive({
  username: '',
  password: '',
})

const peruser = reactive({
  phone: '',
})

// 生命周期钩子
onMounted(() => {
  // 检测是否为移动设备
  checkMobile()
  // 监听窗口大小变化，动态更新isMobile状态
  window.addEventListener('resize', checkMobile)

  // 检查是否有强制登录参数，如果有则清除缓存
  const forceLogin = route.query.force === 'true'
  if (forceLogin) {
    clearAllCache()
  }

  courseId.value = route.query.courseId as string
  toAIPainting.value = route.query.toAIPainting as string

  // 添加阻止iOS缩放的事件处理
  const inputs = document.querySelectorAll('input')
  inputs.forEach(input => {
    input.addEventListener('focus', () => {
      // 添加自定义聚焦类用于样式控制
      input.classList.add('input-focused')
      // 防止双击缩放
      document.documentElement.style.touchAction = 'manipulation'
    })
    input.addEventListener('blur', () => {
      input.classList.remove('input-focused')
      document.documentElement.style.touchAction = ''
    })
  })

  const token = getToken()

  const userId = getUrlParams('userId')
  if (userId) {
    loginnocode({ userId: userId }).then((res: any) => {
      console.log(res)
      if (res.isSuccess) {
        // 存储token到本地
        if (res.token) {
          setToken(res.token)
        }

        // 跳转到主页
        if (courseId.value) {
          sessionStorage.setItem('tabClickId', '2')
          router.push({
            path: '/courseDetails_pc',
            query: { courseId: courseId.value },
          })
        } else if (toAIPainting.value) {
          sessionStorage.setItem('tabClickId', '2')
          router.push({
            path: '/aiPaintingSquare1_pc',
          })
        } else {
          sessionStorage.setItem('tabClickId', '2')
          router.push({
            path: '/',
          })
        }
      } else {
        ElNotification({
          title: '错误',
          message: res.message,
          type: 'error',
        })
      }
    })
  }
})

// 在组件卸载前清除事件监听器
onBeforeUnmount(() => {
  // 移除事件监听器
  const inputs = document.querySelectorAll('input')
  inputs.forEach(input => {
    input.removeEventListener('focus', () => { })
    input.removeEventListener('blur', () => { })
  })

  // 移除窗口大小变化的监听器
  window.removeEventListener('resize', checkMobile)
})

// 检测是否为移动设备
const checkMobile = () => {
  // 使用两种方式判断：屏幕宽度和用户代理
  const isMobileByWidth = window.innerWidth <= 768
  const isMobileByAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)

  isMobile.value = isMobileByWidth || isMobileByAgent
}

// 方法
const isPhoneNo = (phone: string) => {
  const pattern = /^1[3456789]\d{9}$/
  return pattern.test(phone)
}

// 切换登录类型
const switchLoginType = (type: 'hospital' | 'community') => {
  loginType.value = type
  // 清空表单数据
  perUser.username = ''
  perUser.password = ''
}

const login_btn = () => {
  const username = perUser.username
  const password = perUser.password
  if (username.length === 0) {
    ElNotification({
      title: '警告',
      message: '用户名不能为空',
      type: 'warning',
      duration: 2000,
    })
  } else if (password.length === 0) {
    ElNotification({
      title: '警告',
      message: '密码不能为空',
      type: 'warning',
      duration: 2000,
    })
  } else {
    confirm()
  }
}

const confirm = () => {
  // 统一使用hospitalLogin接口，社区和医院都使用用户名/简称登录
  // 打印请求参数，便于调试
  console.log('登录请求参数:', perUser, '登录类型:', loginType.value)

  const loginParams = {
    hospitalName: perUser.username, // 使用用户名/简称登录
    password: perUser.password
  }

  hospitalLogin(loginParams)
    .then((res: any) => {
      console.log('登录响应:', res)
      if (res.status === 200) {
        // 登录成功，存储用户信息和token
        if (res.data) {
          console.log('用户信息:', res.data)

          // 存储医院信息（社区和医院都存储在hospitalInfo中）
          if (res.data.hospitalInfo) {
            localStorage.setItem('hospitalInfo', JSON.stringify(res.data.hospitalInfo))
            localStorage.setItem('hospitalId', res.data.hospitalInfo.id.toString())

            // 判断登录类型（通过hospitalType字段）
            const hospitalType = res.data.hospitalInfo.hospitalType
            console.log('机构类型:', hospitalType)

            // 存储hospitalType到localStorage，供其他页面使用
            localStorage.setItem('hospitalType', hospitalType)
          }

          // 生成统一的token（不论是社区还是医院）
          const userToken = `hospital__${res.data.hospitalInfo?.id || 'unknown'}_${Date.now()}`
          setToken(userToken)
          console.log('Token已设置:', userToken)
        } else {
          // 如果没有用户数据，也设置一个基本token
          setToken('logged_in_user')
        }

        // 根据登录类型显示不同的成功消息
        const loginTypeText = loginType.value === 'hospital' ? '医院' : '社区'
        ElNotification({
          title: '成功',
          message: res.message || `${loginTypeText}登录成功`,
          type: 'success',
          duration: 2000,
        })

        // 跳转到首页dashboard
        router.push({
          path: '/dashboard',
        })
      } else {
        // 根据登录类型显示不同的错误消息
        const loginTypeText = loginType.value === 'hospital' ? '医院' : '社区'
        ElNotification({
          title: '错误',
          message: res.message || `${loginTypeText}登录失败`,
          type: 'error',
          duration: 2000,
        })
      }
    })
    .catch((error: any) => {
      console.error('登录请求失败:', error)
      const loginTypeText = loginType.value === 'hospital' ? '医院' : '社区'
      ElNotification({
        title: '错误',
        message: `${loginTypeText}登录请求失败，请检查网络连接`,
        type: 'error',
        duration: 2000,
      })
    })
}

const getUrlParams = (name: string) => {
  const url = window.location.href
  const queryString = url.split('?')[1]
  if (!queryString) return null

  const urlParams = new URLSearchParams('?' + queryString)
  return urlParams.get(name)
}

// 清除所有缓存数据
const clearAllCache = () => {
  try {
    // 清除token
    removeToken()

    // 清除用户数据
    clearUserData()

    // 清除localStorage中的其他数据（保持为空，因为统一使用hospitalInfo）

    // 清除sessionStorage
    sessionStorage.clear()

    console.log('已清除所有缓存数据')
  } catch (error) {
    console.error('清除缓存时出错:', error)
  }
}

// 跳转到注册页面
const goToRegister = () => {
  router.push({
    path: '/hospital-register',
    query: { type: loginType.value }
  })
}
</script>
<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  position: relative;
  z-index: 1;
  width: 100%;
  overflow-x: hidden;
  background: linear-gradient(135deg, #FFFFFF 0%, #F5F9FA 50%, #E8F5F5 100%);
  background-attachment: fixed;
  /* 防止页面左右滑动 */
}

/* 添加全局样式，防止页面滑动 */
:deep(html),
:deep(body) {
  overflow-x: hidden;
  width: 100%;
  position: relative;
}

.login-content {
  display: flex;
  width: 900px;
  height: 600px;
  background-color: #fff;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(20, 184, 166, 0.15);
  overflow: hidden;
  position: relative;
  margin: 0 auto;
  border: 1px solid rgba(20, 184, 166, 0.2);
}

.login-left {
  flex: 1;
  background: linear-gradient(180deg, #26A69A 0%, #00b3c6 50%, #00c6da 100%);
  color: white;
  padding: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.login-left::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 60%);
  animation: rotate 30s linear infinite;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.brand-info {
  position: relative;
  z-index: 1;
}

.brand-title {
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 15px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.brand-slogan {
  font-size: 18px;
  margin-bottom: 40px;
  opacity: 0.9;
}

.brand-features {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  opacity: 0.9;
}

.feature-item .el-icon {
  font-size: 20px;
}

.login-right {
  flex: 1;
  padding: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-box {
  width: 100%;
  max-width: 350px;
}

.login-title {
  font-size: 28px;
  text-align: center;
  margin-bottom: 20px;
  color: #333;
  font-weight: 600;
}

/* 登录类型切换样式 */
.login-type-toggle {
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  background-color: #f0f2f5;
  border-radius: 8px;
  padding: 4px;
  gap: 4px;
}

.type-btn {
  flex: 1;
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: transparent;
  color: #666;
}

.type-btn.active {
  background: linear-gradient(135deg, #14b8a6, #0d9488);
  color: white;
  box-shadow: 0 2px 8px rgba(20, 184, 166, 0.3);
}

.type-btn:hover:not(.active) {
  background-color: #E0F7FA;
  color: #14b8a6;
}

.input-group {
  margin-bottom: 25px;
}

.input-group label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: #606266;
  font-weight: 500;
}

.phone-input,
.code-input {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  transition: all 0.3s;
  background-color: #f9f9f9;
  overflow: hidden;
  position: relative;
}

.phone-input:focus-within,
.code-input:focus-within {
  border-color: #14b8a6;
  box-shadow: 0 0 0 2px rgba(20, 184, 166, 0.1);
  background-color: #fff;
}

.phone-input .el-icon,
.code-input .el-icon {
  padding: 0 12px;
  color: #909399;
}

.phone-input input,
.code-input input {
  flex: 1;
  padding: 12px 15px 12px 0;
  border: none;
  outline: none;
  font-size: 16px;
  background: transparent;
  width: auto;
  min-width: 0;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.code-btn {
  padding: 0 15px;
  height: 44px;
  background: linear-gradient(135deg, #14b8a6, #0d9488);
  color: white;
  border: none;
  cursor: pointer;
  white-space: nowrap;
  font-size: 14px;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.code-btn:hover {
  background: linear-gradient(135deg, #0d9488, #0f766e);
  box-shadow: 0 2px 8px rgba(20, 184, 166, 0.3);
}

.code-btn.disabled {
  background-color: #a0cfff;
  cursor: not-allowed;
}

.login-btn {
  width: 100%;
  height: 44px;
  background: linear-gradient(135deg, #14b8a6, #0d9488);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  margin-top: 20px;
  position: relative;
  overflow: hidden;
  transition: all 0.3s;
}

.login-btn:hover {
  background: linear-gradient(135deg, #0d9488, #0f766e);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(20, 184, 166, 0.3);
}

.btn-effect {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  transition: all 0.5s;
}

.login-btn:active .btn-effect {
  width: 300px;
  height: 300px;
  opacity: 0;
}

.register-link {
  margin-top: 15px;
  text-align: center;
  font-size: 14px;
  color: #606266;
}

.register-link a {
  color: #14b8a6;
  text-decoration: none;
  font-weight: 500;
  cursor: pointer;
  transition: color 0.3s;
}

.register-link a:hover {
  color: #0d9488;
  text-decoration: underline;
}

.login-tips {
  margin-top: 15px;
  text-align: center;
  font-size: 12px;
  color: #909399;
}

.login-tips a {
  color: #14b8a6;
  text-decoration: none;
  transition: color 0.3s;
}

.login-tips a:hover {
  color: #0d9488;
  text-decoration: underline;
}

/* 响应式调整 */
@media (max-width: 900px) {
  .login-content {
    width: 90%;
    height: auto;
    flex-direction: column;
  }

  .login-left {
    padding: 30px;
  }

  .login-right {
    padding: 30px;
  }
}

@media (max-width: 600px) {
  .login-content {
    width: 95%;
  }

  .login-left {
    display: none;
  }

  /* 移动端验证码按钮样式调整 */
  .code-btn {
    padding: 0 10px;
    font-size: 12px;
    min-width: 80px;
    position: relative;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

/* 移动端右上角标题样式 */
.mobile-header {
  position: fixed;
  top: 0;
  right: 0;
  padding: 15px 20px;
  z-index: 100;
  text-align: right;
}

.mobile-brand-title {
  font-size: 20px;
  font-weight: bold;
  color: #14b8a6;
  margin: 0;
  padding: 0;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.mobile-brand-slogan {
  font-size: 14px;
  color: #14b8a6;
  margin: 0;
  padding: 0;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

/* 移动端底部文本样式 */
.mobile-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px 0;
  text-align: center;
  font-size: 12px;
  color: #666;
  z-index: 100;
}

/* PC端底部文本样式 */
.pc-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px 0;
  text-align: center;
  font-size: 12px;
  color: #666;
  z-index: 100;
}

/* 添加数字人图片样式 */
.digital-human-image {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 200px;
  height: 300px;
  opacity: 0.8;
  z-index: 1;
  background: url('https://oss.arplus.top/avatargpt/aipowerAvatar.png') no-repeat;
  background-size: contain;
  background-position: bottom right;
}
</style>
